module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/超大广角1.cb35213d.png";